<template>
    <button class="show_more" @click="switchState">
        {{ value? $t('dashboard.device_detail.show_less') : $t('show_more') }}
        <i  :class="[value ? 'icon-icon_arrow-up' : 'icon-icon_arrow-down']"></i>
    </button>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    model: {
        prop: 'value',
        event: 'switch'
    },
    props: {
        value: Boolean,
    },
    methods: {
        switchState() {

            this.$emit( 'switch', !this.value );

        }
    }
});
</script>

<style lang="less" scoped>
.show_more {
    border: none;
    padding: 0;
    background-color: transparent;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    font-family: @font_02;
    line-height: normal;
    letter-spacing: 0em;
    color: @brand_light;
    cursor: pointer;

    &:hover {
        color: @brand_light_hover;
    }

    i {
        font-size: 13px;
        margin-left: 4px;
    }
}
</style>
